/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'FilterOpen': {
    width: 29,
    height: 18,
    viewBox: '0 0 29 18',
    data: '<path pid="0" _fill="#00204D" d="M1.25 2.534c.1.13 5.74 7.33 5.74 7.33v6.01c0 .55.45 1 1.01 1h2.01c.55 0 1.01-.45 1.01-1v-6.02s5.49-7.02 5.75-7.34c.26-.32.23-.64.23-.64 0-.55-.45-1-1.01-1H2.01c-.61 0-1.01.48-1.01 1 0 .2.06.44.25.66zM23 3.874l5 5-5 5v-10z" opacity=".5"/>'
  }
})
